/* eslint-disable react/prop-types */
import React from 'react';

import './style.scss';

const Social = ({ positionUid }) => (
    <div className="social-widget-wrapper">
        <script
            data-social-employees={true}
            data-position-uid={positionUid}
            data-css-cache="false"
            data-social-networks="basic"
            data-social-show-title="true"
            type="comeet-social"
        />
    </div>
);

export default Social;
